export const DIRECT = 3; // Direct message: recipient is a user (not a group), but not the same user as the author
export const PRIVATE = 2; // Private post: recipient is a private user or group
export const PROTECTED = 1; // Protected post: recipient is a protected user or group
export const PUBLIC = 0; // Public post
